<section class="content-side mb-30 bg-white">
  <div class="header">
    <div class="mb-30 content-header">
      <h1 class="title-header mb-10">{{ "PrivacyPolicies" | translate }}</h1>
    </div>
    <div class="logo-m247">
      <img alt="logo" [src]="urlIMG + 'logo-red.png'" />
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row>
    <div nz-col nzSpan="24" class="mt-30 mb-30">
      <p>
        <b>1. {{ "privacy_policy_h_1" | translate }}</b>
      </p>

      <p [innerHTML]="'privacy_policy_h1_p1' | translate"></p>

      <p>
        {{ "privacy_policy_h1_p2" | translate }}
      </p>

      <p>
        <b>2. {{ "privacy_policy_h_2" | translate }}</b>
      </p>

      <p [innerHTML]="'privacy_policy_h2_p' | translate"></p>
      <ul class="list-disc" style="margin-left: 30px">
        <li [innerHTML]="'privacy_policy_h2_p1' | translate"></li>
        <li [innerHTML]="'privacy_policy_h2_p2' | translate"></li>
      </ul>

      <p>
        <b>3. {{ "privacy_policy_h_3" | translate }}</b>
      </p>

      <p>
        {{ "privacy_policy_h3_p" | translate }}
      </p>

      <p>
        <b>4. {{ "privacy_policy_h_4" | translate }}</b>
      </p>

      <p [innerHTML]="'privacy_policy_h4_p1' | translate"></p>
      <p [innerHTML]="'privacy_policy_h4_p2' | translate"></p>
      <p [innerHTML]="'privacy_policy_h4_p3' | translate"></p>

      <ul style="margin-left: 30px" class="list-decimal">
        <li
          *ngFor="let item of [].constructor(8); let i = index"
          [innerHTML]="'privacy_policy_h4_li_' + (i + 1) | translate"
        ></li>
      </ul>

      <p [innerHTML]="'privacy_policy_h4_p4' | translate"></p>
      <p [innerHTML]="'privacy_policy_h4_p5' | translate"></p>

      <ul style="margin-left: 30px" class="list-decimal">
        <li
          *ngFor="let item of [].constructor(7); let i = index"
          [innerHTML]="'privacy_policy_h4_p6_' + (i + 1) | translate"
        ></li>
      </ul>

      <p>
        <b>5. {{ "privacy_policy_h_5" | translate }}</b>
      </p>

      <p [innerHTML]="'privacy_policy_h5_1' | translate"></p>
      <p [innerHTML]="'privacy_policy_h5_2' | translate"></p>
      <p [innerHTML]="'privacy_policy_h5_3' | translate"></p>

      <p>
        <b>6. {{ "privacy_policy_h_6" | translate }}</b>
      </p>

      <p [innerHTML]="'privacy_policy_h6_1' | translate"></p>
      <p [innerHTML]="'privacy_policy_h6_2' | translate"></p>

      <p>
        <b>7. {{ "privacy_policy_h_7" | translate }}</b>
      </p>

      <p [innerHTML]="'privacy_policy_h7_1' | translate"></p>

      <p>
        <b>8. {{ "privacy_policy_h_8" | translate }}</b>
      </p>
      <p [innerHTML]="'privacy_policy_h8_1' | translate"></p>
      <p [innerHTML]="'privacy_policy_h8_2' | translate"></p>
      <ul style="margin-left: 30px" class="list-disc">
        <li
          *ngFor="let item of [].constructor(2); let i = index"
          [innerHTML]="'privacy_policy_h8_li_' + (i + 1) | translate"
        ></li>
      </ul>
      <p [innerHTML]="'privacy_policy_h8_3' | translate"></p>
      <p [innerHTML]="'privacy_policy_h8_4' | translate"></p>

      <p>
        <b>9. {{ "privacy_policy_h_9" | translate }}</b>
      </p>
      <p [innerHTML]="'privacy_policy_h9_1' | translate"></p>

      <p>
        <b>10. {{ "privacy_policy_h_10" | translate }}</b>
      </p>
      <p [innerHTML]="'privacy_policy_h10_1' | translate"></p>
      <p [innerHTML]="'privacy_policy_h10_2' | translate"></p>
      <ul style="margin-left: 30px" class="list-disc">
        <li
          *ngFor="let item of [].constructor(2); let i = index"
          [innerHTML]="'privacy_policy_h10_li_' + (i + 1) | translate"
        ></li>
      </ul>
      <p [innerHTML]="'privacy_policy_h10_3' | translate"></p>

      <p>
        <b>11. {{ "privacy_policy_h_11" | translate }}</b>
      </p>

      <p [innerHTML]="'privacy_policy_h11_1' | translate"></p>
      <p>
        <b>12. {{ "privacy_policy_h_12" | translate }}</b>
      </p>

      <p [innerHTML]="'privacy_policy_h12_1' | translate"></p>
      <p [innerHTML]="'privacy_policy_h12_2' | translate"></p>
    </div>
  </div>
</section>
